import React from "react";

export const LazyCardSettingsPage = React.lazy(() => import("./index"));
